module.exports = __webpack_public_path__ + "static/img/a125.daf19f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a125.jpg
// module id = l4NI
// module chunks = 0